function formatAmount(amount) {
    return new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
}

function updateSubmitPrice(bar) {
    const unitPrice = parseFloat(bar.dataset.unitPrice || '0');
    const quantity = parseInt(bar.querySelector('[data-quantity-input]').value, 10) || 1;
    const total = Math.round(unitPrice * quantity * 100) / 100;
    bar.querySelector('[data-quick-add-submit-price]').textContent = `${formatAmount(total)} €`;
}

function populateBar(bar, data) {
    const image = bar.querySelector('[data-quick-add-image]');
    image.src = data.image;
    image.alt = data.name;

    bar.querySelector('[data-quick-add-name]').textContent = data.name;

    const priceText = `${formatAmount(data.price)} € ${data.priceLabel}`.trim();
    bar.querySelector('[data-quick-add-price]').textContent = priceText;
    // Rounded to the displayed unit price (cents) so ×quantity matches what
    // the user sees rather than PricingService's unrounded float.
    bar.dataset.unitPrice = Math.round(data.price * 100) / 100;

    const form = bar.querySelector('[data-quick-add-form]');
    form.action = data.addUrl;
    form.querySelector('[data-quick-add-token]').value = data.token;
    form.querySelector('[data-quantity-input]').value = 1;

    updateSubmitPrice(bar);
}

function showBar(bar) {
    bar.hidden = false;
    requestAnimationFrame(() => bar.classList.add('is-visible'));
}

function hideBar(bar) {
    bar.classList.remove('is-visible');
    bar.addEventListener('transitionend', () => { bar.hidden = true; }, { once: true });
}

/**
 * Catalogue-only: clicking a product card (outside the "Voir le produit"
 * link) opens a shared floating bar to add it to the cart without leaving
 * the grid — see templates/public/partials/_quick_add_bar.html.twig.
 */
function initQuickAddBar() {
    const bar = document.getElementById('quick-add-bar');
    if (!bar) {
        return;
    }

    document.addEventListener('click', (event) => {
        if (event.target.closest('.product-link')) {
            return;
        }

        const trigger = event.target.closest('[data-quick-add-trigger]');
        if (!trigger) {
            return;
        }

        populateBar(bar, {
            name: trigger.dataset.productName,
            image: trigger.dataset.productImage,
            price: parseFloat(trigger.dataset.productPrice),
            priceLabel: trigger.dataset.productPriceLabel,
            addUrl: trigger.dataset.cartAddUrl,
            token: trigger.dataset.cartAddToken,
        });

        showBar(bar);
    });

    bar.querySelector('[data-quick-add-close]').addEventListener('click', () => hideBar(bar));
    bar.querySelector('[data-quantity-input]').addEventListener('change', () => updateSubmitPrice(bar));
}

export default initQuickAddBar;
